import { render, staticRenderFns } from "./RationsTable.vue?vue&type=template&id=765d31f0&scoped=true&lang=pug&"
import script from "./RationsTable.vue?vue&type=script&lang=js&"
export * from "./RationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RationsTable.vue?vue&type=style&index=0&id=765d31f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d31f0",
  null
  
)

export default component.exports